import React from "react";
import { Route, Routes } from "react-router";
import Overview from "pages/v1/Overview";
import Container from "./Container";
import ClaimSupport from "pages/v1/ClaimSupport";
import EmployeeMIS from "pages/v1/EmployeeMis";
import EnrolmentHistory from "pages/v1/EnrolmentHistory";
import Claims from "pages/v1/Claims";
import ClaimsEmployeeMis from "pages/v1/Claims/ClaimsEmployeeMis";
import ClaimsDetail from "pages/v1/Claims/ClaimsDetail";
import PlanOverview from "pages/v1/PlanOverview";
import ECardView from "pages/v1/EmployeeMis/ECardView";
import CompanyProfile from "pages/v1/CompanyProfile";
import CashDeposit from "pages/v1/CashDeposit";
import Transactions from "pages/v1/CashDeposit/Transactions";
import UploadPolicy from "pages/v1/UploadPolicy";
import UploadEnrolment from "pages/v1/UploadEnrolment";
import Utilities from "pages/Utilities";
import ClientIdGenerator from "pages/Utilities/ClientIdGenerator";
import Benefits from "pages/v1/Setup/Benefits";
import InProgress from "pages/v1/UploadEnrolment/InProgress";
import ErrorScreen from "pages/v1/UploadEnrolment/ErrorScreen";
import CashDepositUpdate from "pages/v1/CashDeposit/CashDepositUpdate";
import UserProfile from "pages/v1/UserProfile";
import ChangePassword from "pages/v1/UserProfile/ChangePassword";
import DataCollectionHistory from "pages/v1/DataCollectionHistory";
import GradeEdit from "pages/v1/Setup/GradeEdit";
import Wellness from "pages/v1/Wellness";
import BenefitSetup from "pages/v1/Wellness/BenefitSetup";
import Collect from "pages/v1/DataCollectionHistory/Collect";
import Pending from "pages/v1/DataCollectionHistory/Pending";
import Error from "pages/v1/DataCollectionHistory/Error";
import BenefitSummary from "pages/v1/Wellness/BenefitSummary";
import EnrolmentEdit from "pages/EnrolmentEdit";
import BenefitSummaryPost from "pages/v1/Wellness/BenefitSummaryPost";
import AddDelete from "pages/v1/AddDelete";
import CorporateCompanySelection from "pages/v1/CorporateCompanySelection";
import { userHasViewPermission } from "utlis/utils";

function Router() {
  return (
    <Routes>
      <Route element={<Container />}>
        {userHasViewPermission() || JSON.parse(localStorage.getItem("login_profile"))?.is_multiple_company_mapped ? (
          <>
          <Route index element={<CorporateCompanySelection />} />
          <Route path="/overview" index element={<Overview />} />
          </>
        ) : (
          <Route index element={<Overview />} />
        )}
        <Route path="/claim-support" element={<ClaimSupport />} />
        <Route path="/cash-deposit" element={<CashDeposit />} />
        <Route path="/upload-policy" element={<UploadPolicy />} />
        <Route path="/cash-deposit/transactions" element={<Transactions />} />
        <Route path="/cash-deposit/update" element={<CashDepositUpdate />} />
        <Route path="/plan-overview/:userplan_id" element={<PlanOverview />} />
        <Route path="/enrolments" element={<EnrolmentHistory />} />
        <Route path="/enrolments/edit" element={<EnrolmentEdit />} />
        <Route path="/enrolments/create" element={<UploadEnrolment />} />
        <Route path="/enrolments/in-progress" element={<InProgress />} />
        <Route path="/enrolments/error" element={<ErrorScreen />} />
        <Route path="/employee-mis" element={<EmployeeMIS />} />
        <Route path="/employee-mis/e-cards/:empId" element={<ECardView />} />
        <Route path="/claims" element={<Claims />} />
        <Route path="/claims/mis" element={<ClaimsEmployeeMis />} />
        <Route path="/claims/mis/:employee_number" element={<ClaimsDetail />} />
        <Route path="/profile/company/:type" element={<CompanyProfile />} />
        <Route path="/profile/change-password" element={<ChangePassword />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/utilities" element={<Utilities />} />
        <Route path="/utilities/client-id" element={<ClientIdGenerator />} />
        <Route path="/products/:type" element={<Benefits />} />
        <Route
          path="/data-collection-history"
          element={<DataCollectionHistory />}
        />
        <Route
          path="/data-collection-history"
          element={<DataCollectionHistory />}
        />
        <Route path="/data-collection-history/collect" element={<Collect />} />
        <Route
          path="/data-collection-history/collect/pending"
          element={<Pending />}
        />
        <Route
          path="/data-collection-history/collect/error"
          element={<Error />}
        />
        <Route path="/grade-edit" element={<GradeEdit />} />

        {/* Wellness */}
        <Route
          path="/wellness/setup/summary-post/:benefitId"
          element={<BenefitSummaryPost />}
        />
        <Route path="/wellness/setup/summary" element={<BenefitSummary />} />
        <Route path="/wellness/setup" element={<BenefitSetup />} />
        <Route path="/wellness" element={<Wellness />} />
        <Route path="/add-delete" element={<AddDelete />} />
      </Route>
    </Routes>
  );
}

export default Router;
